import { defineRoute } from '../defineRoute';

export type HowDoesItWorkTenantRouteParams = {
  // ...
};

export type HowDoesItWorkTenantRouteParamsString = {
  // ...
};

export const HowDoesItWorkTenant = defineRoute<
  HowDoesItWorkTenantRouteParams,
  HowDoesItWorkTenantRouteParamsString
>({
  pathname: '/how-does-it-work',
  nlPathname: '/hoe-werkt-het',
  routeParamsStringifier: () => {
    return {};
  },
  routeParamsParser: () => {
    return {};
  },
});
